
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/tutorials/advanced-series-1",
      function () {
        return require("private-next-pages/docs/antara/tutorials/advanced-series-1/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/tutorials/advanced-series-1"])
      });
    }
  